import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
} from '@/components/ui/dropdown-menu'
import { usePageInfo } from 'app/frontend/base/config/queries'
import { useTranslation } from 'react-i18next'
import { ChevronDown } from 'lucide-react'
import GameVersion, {
  gameVersionHref,
  gameVersionLogo,
} from 'app/frontend/types/custom/GameVersion'

const GameSwitcher = ({ className }: { className?: string }) => {
  const { t } = useTranslation()
  const {
    data: { gameVersion },
  } = usePageInfo()

  const gameItem = (version: GameVersion) => {
    return (
      <a key={version} href={gameVersionHref(version)}>
        <DropdownMenuItem className='flex gap-4 w-full pr-4'>
          <figure className='w-24 h-16'>
            <img
              className='w-full h-full object-contain'
              src={gameVersionLogo(version)}
            />
          </figure>

          <div className='flex flex-col gap-0.5'>
            <span className='text-xs text-muted-foreground'>
              {t(`game-versions.${version}.caption`)}
            </span>
            <span
              className={`text-[1rem] leading-tight ${
                version === gameVersion ? 'text-primary' : ''
              }`}
            >
              {t(`game-versions.${version}.name`)}
            </span>
          </div>
        </DropdownMenuItem>
      </a>
    )
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <span
          className={`flex gap-1 items-center cursor-pointer ${
            className ?? ''
          }`}
        >
          <span className='text-base'>
            {t(`game-versions.${gameVersion}.name`)}
          </span>
          <ChevronDown width={12} className='ml-0.5 mt-1 opacity-70' />
        </span>
      </DropdownMenuTrigger>
      <DropdownMenuContent>
        {gameItem('live')}
        <DropdownMenuSeparator />
        {gameItem('classic_progression')}
        <DropdownMenuSeparator />
        {gameItem('classic_anniversary')}
        <DropdownMenuSeparator />
        {gameItem('classic_era')}
      </DropdownMenuContent>
    </DropdownMenu>
  )
}

export default GameSwitcher
